import React from "react";
import { ErrorText } from "..";

export const TextField = ({
  id,
  name,
  type,
  className,
  value,
  onBlur,
  onChange,
  disabled = false,
  reference,
  placeholder,
  mainWrapCls,
  icon,
  isError,
  errorText,
  style,
  step,
  max,
  min
}) => (
  <div>
    <div className={mainWrapCls}>
      <input
        id={id}
        name={name}
        type={type}
        ref={reference}
        className={isError ? "errorField" : className}
        value={value}
        onBlur={onBlur}
        onChange={(e) => onChange(e)}
        disabled={disabled}
        placeholder={placeholder}
        style={style}
        step={step}
        max= {max}
        min={min}
      />
      {icon && <div>{icon}</div>}
    </div>

    {isError && (
      <div>
        <ErrorText text={errorText} />
      </div>
    )}
  </div>
);

TextField.defaultProps = {
  mainWrapCls: "loginInputWrap",
  className: "loginInput",
};
